import hasClass from './hasClass';

export default function removeClass(element, cls) {
   if (hasClass(element, cls)) {
      var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      element.className = element.className.replace(reg, ' ').trim();
   }
}
